(function() {
    'use strict';

    angular
        .module('rms.common')
        .controller('PersonaSelectionController', PersonaSelectionController);

    function PersonaSelectionController($scope, lodash) {
        const panelCtrl = $scope.vm;
        const panelState = lodash.get(panelCtrl, 'options', null);
        const panelOption = lodash.get(panelState, 'structure.options', null);
        const panelModel = lodash.get(panelState, 'model', null);

        var selectedPersona = null;

        toggleButtonDisable();

        console.log({panelCtrl, panelState, panelOption, panelModel});

        panelCtrl.getModel = function () {
            return {selected_persona: selectedPersona};
        }

        panelCtrl.events = {
            selectItem: selectItem,
            isSelected: isSelected,
            hasSelection: hasSelection,
            onLoadItems: onLoadItems,
        }

        function onLoadItems() {
            var selected = lodash.get(panelOption, 'selected', null);
            selectedPersona = lodash.find(panelModel.suggestion_info.suggestion_data, {
                select_id: selected,
            });
            toggleButtonDisable();
        }


        function selectItem(item) {
            selectedPersona = item;
            toggleButtonDisable();
        }

        function isSelected(item) {
            if (hasSelection()) return item.select_id === selectedPersona.select_id;
        }

        function hasSelection() {
            return (selectedPersona);
        }

        function toggleButtonDisable() {
            if (!hasSelection()) {
                panelOption.buttons.confirm_btn.attr.disabled = true;
            } else {
                panelOption.buttons.confirm_btn.attr.disabled = false;
            }
        }
    }
})();